<template>
  <div>
    <counter
      :helper="helper"
      :label="label"
      :name="name"
      :placeholder="placeholder"
      :value="count"
      v-on:input="updateInputs"
    ></counter>

    <div
      class="form-group has-helper"
      v-bind:key="index"
      v-for="(input, index) in values"
    >
      <div class="col-md-4">
        {{ getNiceName(index) }}
      </div>
      <div class="control-container dynamic-input-body col-md-8">
        <input-block
          :value="getValue(input)"
          :name="getName(index, name)"
          v-on:input="updateInputValue($event, index)"
        ></input-block>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<style>
.dynamic-input-body .form-group div:first-child {
  width: 100%;
}
</style>

<script>
import Counter from './Counter.vue';

export default {
  props: {
    helper: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    nicename: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    keyName: {
      type: String,
      required: false
    },
    valueName: {
      type: String,
      default: 'value'
    },
    value: {
      type: Array,
      required: true
    }
  },

  computed: {
    count() {
      return this.values.length;
    }
  },

  data() {
    return {
      values: []
    };
  },

  components: {
    counter: Counter
  },

  methods: {
    getNiceName(index) {
      index = index + 1;
      return `${this.nicename} ${index}`;
    },

    getName(index, name) {
      return `${name}[${index}]`;
    },

    getValue(input) {
      if (this.keyName) {
        return input[this.valueName];
      }

      return input;
    },

    updateInputs(count) {
      if (count === this.count) {
        return;
      }

      if (count > this.count) {
        this.values.push(
          this.keyName ? { [this.keyName]: '', [this.valueName]: '' } : ''
        );
      } else if (count <= 0) {
        this.values = [];
      } else {
        this.values.splice(count, 1);
      }

      this.$emit('input', this.values);
    },

    updateInputValue(value, index) {
      this.values[index] = this.keyName
        ? { ...this.values[index], [this.valueName]: value }
        : value;

      this.$emit('input', this.values);
    }
  },

  watch: {
    value(values) {
      this.values = values;
    }
  }
};
</script>
